// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FS-S","clinicsSelect":"styles_clinicsSelect__22CZH"};